import React, { useState } from "react";
import "./WorkoutTabs.css";
import WorkoutForm from "./WorkoutForm";
import WorkoutAttachments from "../../Attachments/WorkoutAttachments";
import ExerciseList from "./ExerciseList";

const WorkoutTabs = ({
  // WorkoutForm props
  workoutData,
  handleInputChange,
  selectedDays,
  handleDayClick,
  weeks,
  CreateWork,
  EditWork,
  isdisable,
  wid,
  widd,
  pid,
  handleImageFileChange,
  selectedimage,
  image,
  placholder,
  getImageUrl,
  BASE_URL_MEDIA,
  selectedVideoUrl,
  handleDivClick,
  fileInputRef,
  handleSelectVideo,
  isUpLoading,
  progress,
  ProgressBar,
  
  // Exercise props
  setCmodal,
  showExcercise,
  apiexercises,
  setReorder,
  openMergeModal,
  reorder,
  mergeexercises,
  formateSetsinputs,
  addType,
  setAddType,
  setQuickSet,
  handleExerciseClick,
  handleAddType,
  deleteEx,
  duplicateEx,
  openRemoveModal,
  reOrderexcercise,
  payLoad,
  onDragEnd,
  detailset,
}) => {
  const [activeTab, setActiveTab] = useState("details");

  const tabs = [
    { id: "details", label: "Workout Details", icon: "fa-info-circle" },
    { id: "attachments", label: "Attachments", icon: "fa-paperclip" },
    { id: "exercises", label: "Exercises", icon: "fa-dumbbell" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return (
          <WorkoutForm
            workoutData={workoutData}
            handleInputChange={handleInputChange}
            selectedDays={selectedDays}
            handleDayClick={handleDayClick}
            weeks={weeks}
            CreateWork={CreateWork}
            EditWork={EditWork}
            isdisable={isdisable}
            wid={wid}
            handleImageFileChange={handleImageFileChange}
            selectedimage={selectedimage}
            image={image}
            placholder={placholder}
            getImageUrl={getImageUrl}
            BASE_URL_MEDIA={BASE_URL_MEDIA}
            selectedVideoUrl={selectedVideoUrl}
            workoutVideo={workoutData.video}
            handleDivClick={handleDivClick}
            fileInputRef={fileInputRef}
            handleSelectVideo={handleSelectVideo}
            isUpLoading={isUpLoading}
            progress={progress}
            ProgressBar={ProgressBar}
          />
        );
      
      case "attachments":
        return <WorkoutAttachments workoutId={wid ?? widd} programId={pid} />;
      
      case "exercises":
        return (
          <ExerciseList
            isdisable={isdisable}
            wid={wid}
            setCmodal={setCmodal}
            showExcercise={showExcercise}
            apiexercises={apiexercises}
            setReorder={setReorder}
            openMergeModal={openMergeModal}
            reorder={reorder}
            mergeexercises={mergeexercises}
            workoutData={workoutData}
            formateSetsinputs={formateSetsinputs}
            addType={addType}
            setAddType={setAddType}
            setQuickSet={setQuickSet}
            handleExerciseClick={handleExerciseClick}
            handleAddType={handleAddType}
            deleteEx={deleteEx}
            duplicateEx={duplicateEx}
            pid={pid}
            widd={widd}
            openRemoveModal={openRemoveModal}
            reOrderexcercise={reOrderexcercise}
            payLoad={payLoad}
            onDragEnd={onDragEnd}
            detailset={detailset}
          />
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="pw_workout-page">
      {/* Page Header */}
      <div className="pw_page-header">
        <button 
          className="pw_back-btn"
          onClick={() => window.history.back()}
        >
          <i className="fa fa-arrow-left"></i>
        </button>
        <h1 className="pw_page-title">
          {isdisable && !wid ? "Create Workout" : "Update Workout"}
        </h1>
      </div>

      {/* Tabbed Content */}
      <div className="pw_tabs-container">
        <div className="pw_tabs-header">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`pw_tab ${activeTab === tab.id ? "pw_active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`fa ${tab.icon}`} style={{ marginRight: '8px' }}></i>
              {tab.label}
            </button>
          ))}
        </div>
        
        <div className="pw_tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default WorkoutTabs;
